import { resolvePricingCategoryFromPlans } from './subscriptionPricingCategory';

/** @typedef {'insight' | 'premium' | 'pro' | 'japan'} DisplayPricingCategory */

const JAPAN_COUNTRY_CODE = 'JP';

/**
 * Customer country from localStorage (`userCountry`), set at login from isoCountryCode.
 * @returns {string} Uppercase ISO country code (e.g. 'JP', 'US')
 */
export function getCustomerCountryCode() {
  try {
    return String(localStorage.getItem('userCountry') || '')
      .trim()
      .toUpperCase();
  } catch {
    return '';
  }
}

/**
 * @param {string} [countryCode]
 * @returns {boolean}
 */
export function isJapanCustomer(countryCode = getCustomerCountryCode()) {
  return (
    String(countryCode || '')
      .trim()
      .toUpperCase() === JAPAN_COUNTRY_CODE
  );
}

/**
 * Resolve UI pricing context: Japan customers use unified JPY tiered pricing (no cohort / loyalty differentiation).
 *
 * @param {Record<string, { planType?: string }|null>|null|undefined} plans
 * @returns {{
 *   isJapanCustomer: boolean,
 *   displayPricingCategory: DisplayPricingCategory,
 *   cohortPricingCategory: 'insight' | 'premium' | 'pro',
 *   pricingCurrency: 'JPY' | 'USD',
 *   premiumCardLayout: boolean,
 *   useConfigPricingOnly: boolean,
 * }}
 */
export function resolveDisplayPricingContext(plans) {
  const cohortPricingCategory = resolvePricingCategoryFromPlans(plans);
  const japan = isJapanCustomer();

  if (japan) {
    return {
      isJapanCustomer: true,
      displayPricingCategory: 'japan',
      cohortPricingCategory,
      pricingCurrency: 'JPY',
      premiumCardLayout: false,
      useConfigPricingOnly: true
    };
  }

  return {
    isJapanCustomer: false,
    displayPricingCategory: cohortPricingCategory,
    cohortPricingCategory,
    pricingCurrency: 'USD',
    premiumCardLayout: cohortPricingCategory === 'premium',
    useConfigPricingOnly: false
  };
}
